import React, { FC } from "react";
import { WidgetProps, WidgetType } from "@commons-monorepo/index";
import {
  HighLightBannerConfig,
  HighLightBannerData,
  useAnalytics,
} from "@commons-monorepo/index";
import HighlightBannerSkin2 from "./skins/highlight-banner-skin-2/highlight-banner-skin-2";
import HighlightBannerSkin1 from "./skins/highlight-banner-skin-1/highlight-banner-skin-1";

const HighLightBanner: FC<
  WidgetProps<HighLightBannerData, HighLightBannerConfig>
> = ({ id, data, config, type, theme, storeMetadata, localConfig }) => {
  const [logEvent] = useAnalytics({ storeMetadata });

  const logClick = (source: string) => {
    logEvent("select_button", {
      user_type: "buyer",
      platform: "web",
      option: (config as HighLightBannerConfig).banner_type_information,
      event_subtype: "highlight_banner",
      source,
      highlight_banner_id: type === WidgetType.BANNER_1 ? "1" : "2",
    });
  };
  const props: {
    data: HighLightBannerData;
    config: HighLightBannerConfig;
    type: WidgetType;
    log: (source: string) => void;
  } = {
    data: data as unknown as HighLightBannerData,
    config: config as HighLightBannerConfig,
    type,
    log: logClick,
  };

  return (
    <div id={id}>
      {type === WidgetType.BANNER_1 && (
        <HighlightBannerSkin1
          data={props.data}
          config={props.config}
          type={props.type}
          log={props.log}
          theme={theme}
          storeMetadata={storeMetadata}
          localConfig={localConfig}
        />
      )}
      {type === WidgetType.BANNER_2 && (
        <HighlightBannerSkin2
          data={props.data}
          config={props.config}
          type={props.type}
          log={props.log}
          theme={theme}
          storeMetadata={storeMetadata}
          localConfig={localConfig}
        />
      )}
    </div>
  );
};

export default HighLightBanner;
